/*eslint-disable*/
import React, { Component } from 'react'
import FormikLogin from '../../components/loginComponent/loginForm'

export default class LoginView extends Component {
    render() {
        return (
            <React.Fragment>
                <FormikLogin />
            </React.Fragment>
        )
    }
}
